import styled from "styled-components";
import BulletPoint from "../../../assets/sprites/elements/bullet.gif";

export const List = styled.ul`
  list-style-image: url(${BulletPoint});
`;

export const ListItem = styled.li``;
